"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemSwitch = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
require("@/components/common/switch");
/**
 * radio·checkbox와 달리 전용 non-menu 그룹 wrapper가 없어 menu 안(설정 목록)과
 * 독립 사용(폼·필터 시트) 둘 다에 놓인다. role은 겉모습이 아니라 놓이는 부모로 정하므로,
 * 실제 부모가 role=menu일 때만 menuitemcheckbox로 읽히고 그 밖에서는 switch로 읽힌다.
 */
let MenuItemSwitch = class MenuItemSwitch extends (0, menu_item_utils_1.withMenuItemToggleState)((0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement)) {
    constructor() {
        super(...arguments);
        this.rowRole = 'switch';
    }
    connectedCallback() {
        super.connectedCallback();
        const group = this.closest('mm-menu-item-group');
        this.rowRole = group?.role === 'menu' ? 'menuitemcheckbox' : 'switch';
    }
    render() {
        return (0, menu_item_utils_1.renderMenuItemToggleRow)(this, this.rowRole, this.renderAction());
    }
    renderAction() {
        // 행(row)이 role·상태·상호작용을 소유하므로 내부 컨트롤은 시각 표시 전용(inert)이다.
        return (0, lit_1.html) `
      <mm-switch
        slot="trailing"
        inert
        aria-hidden="true"
        .checked=${this.checked}
        ?disabled=${this.disabled}
      ></mm-switch>
    `;
    }
};
MenuItemSwitch.styles = [menu_item_styles_1.menuItemStyles];
__decorate([
    (0, decorators_js_1.state)()
], MenuItemSwitch.prototype, "rowRole", void 0);
MenuItemSwitch = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-switch')
], MenuItemSwitch);
exports.MenuItemSwitch = MenuItemSwitch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVudS1pdGVtLXN3aXRjaC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1lbnUtaXRlbS1zd2l0Y2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUF3RDtBQUl4RCxxRkFBK0U7QUFDL0UsbUZBS3NEO0FBQ3RELHNDQUFtQztBQUVuQzs7OztHQUlHO0FBRUksSUFBTSxjQUFjLEdBQXBCLE1BQU0sY0FBZSxTQUFRLElBQUEseUNBQXVCLEVBQUMsSUFBQSwwQ0FBd0IsRUFBQyxnQkFBVSxDQUFDLENBQUM7SUFBMUY7O1FBRVksWUFBTyxHQUEwQixRQUFRLENBQUE7SUF3QjVELENBQUM7SUF0QkMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsTUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBZ0Isb0JBQW9CLENBQUMsQ0FBQTtRQUMvRCxJQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssRUFBRSxJQUFJLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFBO0lBQ3ZFLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLHlDQUF1QixFQUFDLElBQUksRUFBRSxJQUFJLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxDQUFBO0lBQ3pFLENBQUM7SUFFTyxZQUFZO1FBQ2xCLHlEQUF5RDtRQUN6RCxPQUFPLElBQUEsVUFBSSxFQUFBOzs7OzttQkFLSSxJQUFJLENBQUMsT0FBTztvQkFDWCxJQUFJLENBQUMsUUFBUTs7S0FFNUIsQ0FBQTtJQUNILENBQUM7O0FBeEJNLHFCQUFNLEdBQUcsQ0FBQyxpQ0FBYyxDQUFDLENBQUE7QUFDdkI7SUFBUixJQUFBLHFCQUFLLEdBQUU7K0NBQWtEO0FBRi9DLGNBQWM7SUFEMUIsSUFBQSw2QkFBYSxFQUFDLHFCQUFxQixDQUFDO0dBQ3hCLGNBQWMsQ0EwQjFCO0FBMUJZLHdDQUFjIn0=